import React from "react";

import useError from "@hooks/useError";
import useStores from "@hooks/useStores";
import withStyles from "@framework/src/libs/withStyles";
import useStyles from "@hooks/useStyles";

import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import FacebookLogin from "@components/Global/Social/FacebookLogin";
import GoogleLogin from "@components/Global/Social/GoogleLogin";

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import { adjective as clientAdj } from "@language/client";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import FBIcon from "@components/Global/Custom/Icons/FBIcon";
import GoogleIcon from "@components/Global/Custom/Icons/GoogleIcon";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import AppleIcon from "@material-ui/icons/Apple";

const { FB_APP_ID, GOOGLE_CLIENT_ID } = process.env;

const SignupOptions = ({}) => {
	const classes = useStyles("ProSignupFunnel");

	const {
		proSignupFunnelModalStore,
		proSignupFunnelStore,
		signupOptionsStore: store,
	} = useStores();
	const [ErrorTemplate, onError] = useError();

	const fbCallbackHandler = (response) =>
		store.fbCallback(response).catch(onError);
	const googleCallbackHandler = (response) =>
		store.googleCallback(response).catch(onError);
	const signupWithEmailHandler = () =>
		(proSignupFunnelStore.signupWithEmail = true);

	return (
		<React.Fragment>
			<DialogTitle id="scroll-dialog-title" disableTypography>
				{/*TODO: CLOSE BUTTON DOESNT WORK*/}
				<IconButton
					aria-label="close"
					className={classes.closeModal}
					onClick={() => proSignupFunnelModalStore.onClose()}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<Box p={{ xs: 0, sm: "0px 16px" }}>
					<Box mb={5} mt={5}>
						<div className={classes.modalHead}>Create your free account</div>
						<p>Sign up to start hearing from new customers.</p>
					</Box>
					<Box
						component={"p"}
						fontSize={12}
						mb={7}
						color={"grey.700"}
						lineHeight={1.5}
					>
						By selecting Sign up, you agree to our{" "}
						<Link href="/terms-of-service" target={"_blank"}>
							terms of service
						</Link>{" "}
						and{" "}
						<Link href="/privacy-policy" target={"_blank"}>
							privacy policy
						</Link>
						.
					</Box>

					<Grid container spacing={4}>
						<Grid item xs={12}>
							<Button
								onClick={signupWithEmailHandler}
								color={"primary"}
								fullWidth
								disableElevation
								size={"large"}
								variant="contained"
								className={classes.btn}
								startIcon={<MailOutlineIcon />}
							>
								Sign up with email
							</Button>
						</Grid>
						{FB_APP_ID && (
							<Grid item xs={12}>
								<FacebookLogin
									appId={FB_APP_ID}
									callback={fbCallbackHandler}
									className={classes.buttonSocial}
									fullWidth
									disableElevation
									size={"large"}
									variant="contained"
									onFailure={onError}
									startIcon={<FBIcon />}
								>
									Sign up with Facebook
								</FacebookLogin>
							</Grid>
						)}
						{GOOGLE_CLIENT_ID && (
							<Grid item xs={12}>
								<GoogleLogin
									callback={googleCallbackHandler}
									className={classes.buttonSocial}
									fullWidth
									client_id={GOOGLE_CLIENT_ID}
									disableElevation
									size={"large"}
									variant="contained"
									startIcon={<GoogleIcon />}
									onFailure={onError}
									button_name="Sign up with Google"
								/>
							</Grid>
						)}
						{/*<Grid item xs={12}>*/}
						{/*    <Button*/}
						{/*        className={classes.buttonSocial}*/}
						{/*        fullWidth*/}
						{/*        disableElevation*/}
						{/*        size={"large"}*/}
						{/*        variant="contained"*/}
						{/*        startIcon={<AppleIcon/>}*/}
						{/*    >*/}
						{/*        Sign up with Apple*/}
						{/*    </Button>*/}
						{/*</Grid>*/}
					</Grid>

					<Box
						alignItems={"center"}
						justifyContent={"center"}
						display={"flex"}
						mt={6}
						mb={3}
					>
						<Box fontSize={13} mr={2}>
							Already have an account?
						</Box>
						<div>
							<Button href={"/login"} size={"small"} color="primary">
								Log in
							</Button>
						</div>
					</Box>

					<ErrorTemplate autoHideDuration={20000} />
				</Box>
			</DialogContent>
		</React.Fragment>
	);
};

export default SignupOptions;
